module.exports = __webpack_public_path__ + "static/media/48.e11119e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/48.jpg
// module id = 581
// module chunks = 0